<template>
    <div>
        <slot></slot>
        <input
            :ref="$attrs.name"
            class="form-control"
            @blur="search"
            @focusin="clearErrors"
            v-bind="$attrs"
            v-model="val"
        />
        <a class="text-danger" v-if="duplicatesFound" :href="duplicateSearchUrl"
            >Sök befintlig kontakt?<i class="fal fa-search"></i
        ></a>
        <small class="text-danger" v-if="telephone && invalidPhoneNumber"
            >Telefonnumret är ogiltigt</small
        >
    </div>
</template>

<style scoped lang="css"></style>

<script>
export default {
    name: "DuplicateValidatedInput",
    inheritAttrs: false,
};
</script>

<script setup>
import { route } from "ziggy";
import { computed, onMounted, ref, useAttrs } from "vue";
import "intl-tel-input/build/css/intlTelInput.css";
const attrs = useAttrs();
const props = defineProps({
    field: {
        type: String,
        required: false,
    },
    value: String,
    telephone: {
        type: Boolean,
        required: false,
        default: false,
    },
    initialCountry: {
        type: String,
        required: false,
        default: "SE",
    },
});
const val = ref(null);
const duplicatesFound = ref(false);
const telInput = ref(null);
const invalidPhoneNumber = ref(false);
const duplicateSearchUrl = computed(() => {
    return route("quotes.index", {
        q: props.telephone ? telInput.value.getNumber() : val.value,
    });
});
function clearErrors(e) {
    duplicatesFound.value = false;
    invalidPhoneNumber.value = false;
}
async function search(e) {
    if (!e.target.value) {
        return;
    }
    if (props.telephone && !telInput.value.isValidNumber()) {
        invalidPhoneNumber.value = true;
        return;
    }
    const value = props.telephone ? telInput.value.getNumber() : e.target.value;
    if (value === props.value) {
        return;
    }
    const url = route("quotes.search", {
        field: props.field ?? attrs.name,
        q: value,
    });
    try {
        const response = await axios.get(url);
        duplicatesFound.value = response.data.length > 0;
    } catch (e) {
        console.log("Failed to search quotes");
        console.log(e);
    }
}
onMounted(() => {
    const input = document.querySelector(`input[name="${attrs.name}"]`);
    if (props.telephone) {
        telInput.value = window.IntlTelInput(input, {
            initialCountry: props.initialCountry,
            separateDialCode: true,
            hiddenInput: (telInputName) => {
                return {
                    phone: telInputName,
                    country: `${telInputName}_country`,
                };
            },
        });
        if (props.value) {
            telInput.value.setNumber(props.value);
        }
        return;
    }
    val.value = props.value;
});
</script>
